import cn from 'classnames';
import * as React from 'react';

import FontAwesome from 'components/FontAwesome';
import ToggleButton, { ToggleButtonProps } from './ToggleButton';
import { block } from './utils';

type Props = ToggleButtonProps;

const UnderlineToggle: React.SFC<Props> = ({ className, ...buttonProps }) => (
  <ToggleButton
    className={cn(block('underline-toggle'), className)}
    {...buttonProps}
  >
    <FontAwesome icon="underline" />
  </ToggleButton>
);

export default UnderlineToggle;
export { Props as UnderlineToggleProps };
